import React from 'react';
import EditorSidebar from './EditorSidebar';

const AppLayout = ({
  vibe,
  selectedPath,
  onSelectFile,
  workspaceMode,
  explorerOpen,
  explorerWidth,
  chatOpen,
  chatWidth,
  aiPinned,
  onToggleExplorer,
  onToggleChat,
  onChatWidthChange,
  onExplorerWidthChange,
  chat,
  preview,
  onCreateFile,
  onCreateFolder,
  onRename,
  onDelete,
  more,
  moreMounted,
  terminal,
  children,
}) => {
  const codeActive = workspaceMode === 'code';
  const previewActive = workspaceMode === 'preview';
  const moreActive = workspaceMode === 'more';
  const width = chatWidth || 380;

  const startResize = (event) => {
    if (!onChatWidthChange) return;
    event.preventDefault();
    const startX = event.clientX;
    const startWidth = width;
    const move = (pointerEvent) => {
      onChatWidthChange(startWidth + (pointerEvent.clientX - startX));
    };
    const stop = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', stop);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', stop);
  };

  return (
    <div className="vibe-ide d-flex flex-column">
      <div className="vibe-ide-body d-flex flex-grow-1 overflow-hidden">
        <aside
          className={`vibe-ai-column${chatOpen ? ' is-open' : ''}${aiPinned ? '' : ' is-floating'}`}
          style={{ '--vibe-ai-width': `${width}px` }}
          aria-label="AI workspace"
        >
          {chat}
          <button
            type="button"
            className="vibe-ai-resizer"
            aria-label="Resize AI chat"
            title="Drag to resize AI chat"
            onPointerDown={startResize}
          />
        </aside>
        {chatOpen ? null : (
          <button
            type="button"
            className="dc-chat-reveal"
            title="Show AI chat"
            aria-label="Show AI chat"
            onClick={onToggleChat}
          >
            <i className="wb webconnect-layout-text-sidebar" aria-hidden="true" />
          </button>
        )}
        <main className="vibe-ide-main d-flex flex-column flex-grow-1 overflow-hidden min-w-0">
          <div className={`vibe-mode vibe-mode--code${codeActive ? ' is-active' : ''}`}>
            {explorerOpen ? (
              <EditorSidebar
                vibe={vibe}
                selectedPath={selectedPath}
                onSelectFile={onSelectFile}
                onCollapse={onToggleExplorer}
                explorerWidth={explorerWidth}
                onExplorerWidthChange={onExplorerWidthChange}
                onCreateFile={onCreateFile}
                onCreateFolder={onCreateFolder}
                onRename={onRename}
                onDelete={onDelete}
              />
            ) : (
              <button
                type="button"
                className="dc-explorer-reveal"
                title="Show explorer"
                aria-label="Show explorer"
                onClick={onToggleExplorer}
              >
                <i className="wb webconnect-folder" aria-hidden="true" />
              </button>
            )}
            <div className="vibe-editor-slot">{children}</div>
          </div>
          <div className={`vibe-mode vibe-mode--preview${previewActive ? ' is-active' : ''}`}>
            {preview}
          </div>
          <div
            className={`vibe-mode vibe-mode--terminal${
              workspaceMode === 'terminal' ? ' is-active' : ''
            }`}
          >
            {terminal}
          </div>
          {moreMounted ? (
            <div className={`vibe-mode vibe-mode--more${moreActive ? ' is-active' : ''}`}>
              {more}
            </div>
          ) : null}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
